const routes = [
    {
        path: "/library-reservations",
        component: () => import("../pages/Index"),
        meta:{
            isAuthenticated: true,
            isStudent: true,
        }
    },
    {
        path: "/my-library-reservations",
        component: () => import("../myReservations/pages/Index"),
        meta:{
            isAuthenticated: true,
            isStudent: true,
        }
    }
];

export default routes;
